<template>
    <div class="checkout-delivery-warehouses">
        <DefSelectSearch
            :value="getActiveWarehouseName"
            :required="true"
        >
            <template #header>
                {{ getActiveWarehouseName }}
            </template>
            <template #placeholder>
                {{ messages.department }}
            </template>
            <template #search>
                <input
                    type="text"
                    @input="handlerInput"
                >
            </template>
            <div
                v-for="item in warehouses"
                @click="setWhereHouse(item)"
            >
                {{ item.UF_NAME }}
            </div>
        </DefSelectSearch>
        <DefLink
            @click="isOpenMap = true"
            class="checkout-delivery-warehouses__link"
        >
            {{ messages.showOnMap }}
        </DefLink>

        <DefSlideModal
            :active="isOpenMap"
            @close="isOpenMap = false"
        >
            <template #title>
                {{ messages.postOfficeMap }}
            </template>

            <DefMap
                @handlerSelectShop="selectWarehouseFromMap"
                :result="mapSettings.zoom && mapSettings"
            >
                <div
                    v-for="warehouse in warehouses"
                    :lat="warehouse.UF_POS_Y"
                    :lng="warehouse.UF_POS_X"
                    :open="warehouse.UF_POS_Y == mapSettings.center.lat && warehouse.UF_POS_X == mapSettings.center.lng"
                    class="def-map-popup"
                >
                    <h6 class="def-map-popup__title">{{ warehouse.UF_NAME }}</h6>
                    <p class="def-map-popup__text">{{ warehouse.UF_PHONE }}</p>

                    <p class="def-map-popup__text">{{ warehouse.UF_SCHEDULE[getWeekDay] }}</p>

                    <button type="button" class="def-map-popup__button">
                        <span>{{ messages.choose }}</span>
                    </button>
                </div>
            </DefMap>
        </DefSlideModal>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import DefSelectSearch from "../../../def/DefSelect/DefSelectSearch";
import DefSelectWrapper from "../../../def/DefSelect/DefSelectWrapper";
import DefLink from "../../../def/DefLink/DefLink";
import DefSlideModal from "../../../def/DefSlideModal/DefSlideModal";
import DefMap from "../../../def/DefMap/DefMap";

export default {
    name: 'CheckoutDeliveryWarehouses',
    props: ['result', 'currentCity'],
    data() {
        return {
            isOpenMap: false,
            mapSettings: {
                center: {}
            },
        }
    },
    components: {
        DefSelectSearch,
        DefSelectWrapper,
        DefLink,
        DefSlideModal,
        DefMap,
    },
    computed: {
        ...mapState({
            warehouses: ({ cities }) => cities.data.warehouses,
            deliveryProps: ({ checkout }) => checkout?.data?.vue?.delivery?.props,
            requestData: ({ checkout }) => checkout?.data?.vue?.requestData,
            messages: ({ checkout }) => checkout?.data?.vue?.delivery?.messages,
        }),
        getInputName() {
            return Object.values(this.deliveryProps)?.find(el => el.CODE === 'NP_DEPARTMENT')?.inputName;
        },
        getActiveWarehouseName() {
            return this.requestData[ this.getInputName ];
        },
        /**
         * 👉️ Monday Tuesday Wednesday Thursday Friday Saturday Sunday
         * @returns {string}
         */
        getWeekDay() {
            return new Date().toLocaleString(
                'en-US', { weekday: 'long' }
            );
        }
        // getActiveWarehouseId(){
        //     return this.requestData[ this.getInputName ];
        // },
        // getActiveWarehouseName() {
        //     return this.warehouses?.find(el => el.UF_XML_ID === this.getActiveWarehouseId)?.UF_NAME;
        // }
    },
    methods: {
        ...mapMutations({
            setRequestData: 'checkout/setRequestData'
        }),
        ...mapActions({
            getWarehouses: 'cities/getWarehouses',
            setAjax: 'checkout/setAjax',
        }),
        handlerInput({ target: { value } }) {
            this.getWarehouses({
                UF_XML_ID: this.currentCity?.UF_XML_ID,
                warehouse: value,
            });
        },
        setWhereHouse(item) {
            this.mapSettings = {
                center: {
                    lat: +item.UF_POS_Y,
                    lng: +item.UF_POS_X,
                },
                zoom: 18,
            }

            this.setRequestData({ name: this.getInputName, value: item.UF_NAME});
            this.setAjax();
        },
        /**
         * add checking on 0.000000000000000
         * @param lat
         * @param lng
         */
        selectWarehouseFromMap({ lat, lng }) {
            const selectedWarehouse = this.warehouses.find(el => {
                if (el.UF_POS_Y === lat && el.UF_POS_X === lng) {
                    return true;
                }
                return false;
            });

            this.mapSettings = {
                center: {
                    lat: +lat,
                    lng: +lng,
                },
                zoom: 18,
            }

            this.setWhereHouse(selectedWarehouse);
        }
    },
    watch: {
        currentCity(newValue) {
            this.getWarehouses({
                UF_XML_ID: newValue?.UF_XML_ID,
                warehouse: '',
            });
        }
    },
    mounted() {
        try {
            this.getWarehouses({
                UF_XML_ID: this.currentCity?.UF_XML_ID,
                warehouse: '',
            });
        } catch (err) {
            console.error(err);
        }
    }
}
</script>

<style lang="scss" scoped>
.checkout-delivery-warehouses{
    &__link{
        display: block;
        font-weight: 500;
        font-size: rem(12);
        line-height: 120%;
        margin-top: 16px;
        @include point-md{
            position: absolute;
            top: 50%;
            right: -24px;
            transform: translate(100%, -50%);
            margin-top: 0;
        }
    }
    :deep(.def-map){
        height: 100%;
    }
    :deep(.def-slide-modal__scroll){
        margin-bottom: 23px;
        @include point-md{
            margin-bottom: 28px;
        }
        @include point-lg{
            margin-bottom: 60px;
        }
    }
    @include point-md{
        position: relative;
    }
}
</style>